module.exports = __webpack_public_path__ + "img/logo_black.ec60c24b.png";